import { configureStore } from "@reduxjs/toolkit";
import toastReducers from './features/toast/toastSlice'
import drawerReducer from './features/drawer/drawer.slice'

export const store = configureStore({
  reducer: {
    toast: toastReducers,
    drawer: drawerReducer
  }
})

// ✅ Types inferred from store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
